import { platform } from '../../device/platform'
import { IMicrofront, MinimalVersion } from '../../../interfaces/MFE/IMicrofront'
import { getMainModulesUrl } from './main-modules-url'
import getScreenType from '../../device'
import { Tenant } from '../../tenant'
import { filesystem } from '..'

export function initGlobalVariables ({
  microfronts,
  initialToken,
  memoryModules
}: {
  microfronts: IMicrofront[]
  initialToken: string | undefined
  memoryModules: MinimalVersion[]
}): void {
  window.mainUrls = getMainModulesUrl({ discovered: microfronts, downloaded: memoryModules })
  window.AURA_MODULES_CONFIG = {}
  window.MODULES_STATIC_CONFIG = {
    APIMANAGER: {
      sessionInfo: initialToken ?? '',
      _baseUrl: new Tenant().getAPIBaseURL(),
      FILESYSTEM: filesystem,
    },
    FILESYSTEM: filesystem,
    SCREEN_TYPE: getScreenType(),
    PLATFORM: platform,
    EVENTS: {
      REDUX_STORE_CHANGE_EVENT: 'ARCHITECTURE_REDUX_STORE_CHANGED_EVENT',
      HANDLERS_CHANGE_EVENT: 'ARCHITECTURE_HANDLERS_CHANGED_EVENT',
      MAP_CHANGE_EVENT: 'ARCHITECTURE_MAP_CHANGED_EVENT',
      PLUGINS_GEOLOCATION_POSITION_CHANGE_EVENT: 'PLUGINS_GEOLOCATION_POSITION_CHANGED_EVENT'
    }
  }
}